import { FallOutlined, InfoCircleOutlined, LoadingOutlined, RiseOutlined } from "@ant-design/icons";
import {
  ConfigProvider,
  DatePicker,
  Drawer,
  Radio,
  RadioChangeEvent,
} from "antd";
import React, { useEffect, useState } from "react";
import locale from "antd/es/date-picker/locale/ru_RU";
import { useSelector } from "react-redux";
import { getFeedFilter } from "../redux/selectors/feed-filter.selectors";
import { getProduct, getThread } from "../redux/selectors";
import TonalStatistic from "./TonalStatisticSmall";

type Props = {
  type: string;
};

const TopSources = ({ type }: Props) => {
  const [value, setValue] = useState("today");
  const { RangePicker } = DatePicker;
  const feedFilter = useSelector(getFeedFilter);
  const options = [
    { label: " Другое", value: "period" },
    { label: "Сегодня", value: "today" },
    { label: "7д", value: "week" },
    { label: "1м", value: "month" },
  ];
  const thread = useSelector(getThread);
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [avatarNotLoaded, setAvatarNotLoaded] = useState(false);
  const [dateString, setDateString] = useState([
    feedFilter.from,
    feedFilter.to,
  ]);
  const [keys, setKeys] = useState([
    { title: "Ново-Ярославский нефтеперерабатывающий завод (Славнефть-ЯНОС)", trusted: 65, percent: 12.9 },
    { title: "Энергосберегающие Системы Отопления", trusted: 46, percent: 6.18 },
    { title: "Консервный завод Поречский", trusted: 28, percent: 3.74 },
    { title: "Станки трейд", trusted: 26, percent: 15.63 },
    { title: "Даниловский завод деревообрабатывающих станков (ДЗДС)", trusted: 21, percent: 6.74 },
    { title: "Ярославский завод ЖБК", trusted: 9, percent: 3.12 },
  ]);

  useEffect(() => {
    type == "inc" ?
    setKeys(keys.slice(0,3)) :
    setKeys(keys.slice(2,5))
  }, []);

  const showDrawer = () => {
    setOpen(true);
  };

  const onClose = () => {
    setOpen(false);
  };

  const onPeriodChange = (value: any, dateString: string[]): void => {
    setDateString(dateString);
  };

  const onChange = ({ target: { value } }: RadioChangeEvent) => {
    setValue(value);
    if (value == "today")
      setDateString([
        new Date().toJSON().split("T")[0],
        new Date().toJSON().split("T")[0],
      ]);
    if (value == "week") {
      const start = new Date();
      start.setDate(start.getDate() - 6);
      setDateString([
        start.toJSON().split("T")[0],
        new Date().toJSON().split("T")[0],
      ]);
    }
    if (value == "month") {
      const start = new Date();
      start.setDate(start.getDate() - 29);
      setDateString([
        start.toJSON().split("T")[0],
        new Date().toJSON().split("T")[0],
      ]);
    }
  };

  return (
    <div className="white-block">
      <div className="flex-space margin-bottom">
        <p className="block-title">
        Рейтинг предприятий с {type == "inc" ? "положительной" : "отрицательной"} статистикой
          {/*<InfoCircleOutlined className="info" onClick={showDrawer} />*/}
        </p>
        <div className="flex">
          <ConfigProvider
            theme={{
              components: {
                Radio: {
                  buttonSolidCheckedColor: "#4FD1C5",
                  buttonSolidCheckedBg: "rgba(0, 0, 0, 0.1)",
                  colorPrimary: "rgba(0, 0, 0, 0.1)",
                  buttonSolidCheckedHoverBg: "rgba(0, 0, 0, 0.2)",
                },
              },
            }}
          >
            <Radio.Group
              options={options}
              onChange={onChange}
              value={value}
              optionType="button"
              buttonStyle="solid"
            />
          </ConfigProvider>

          {value == "period" && (
            <RangePicker
              format={"DD-MM-YYYY"}
              onChange={onPeriodChange}
              style={{ width: "278px" }}
              className="choose-period"
              allowClear={false}
              locale={locale}
            />
          )}
        </div>
      </div>
      {loading ? (
        <div className="feed-posts-loader">
          <LoadingOutlined />
        </div>
      ) : (
        <div className="grid3">
          {keys?.map((item: any, id) => (
            <div className="grid-block gray-block" key={id}>
              <div className="margin-bottom">
                <a
                  href={item?.url}
                  target="_blank"
                  className="flex align-block"
                >
                  {(
                    <div className="user-widget">
                      <div className="user-img">
                        <div className={"flex-c"}></div>
                        {item.title?.split(" ")[0]?.slice(0, 1).toUpperCase() ||
                          ""}{" "}
                        {item.title?.split(" ")[1]?.slice(0, 1).toUpperCase() ||
                          ""}
                      </div>
                    </div>
                  )}
                  {/*findSource(item?.key)*/}
                  <div className="block-title top-post__text">{item.title}</div>
                </a>
              </div>
              <div className="margin-bottom">
                <div className="flex margin-bottom mobile-flex">
                  <div className="title-small">
                    {item?.trusted?.toFixed(0)}
                  </div>
                  {type == "inc" ? (
                    <div className="green green-bg">
                      <RiseOutlined /> +{item?.percent?.toFixed(2)}%
                    </div>
                  ) : (
                    <div className="red red-bg">
                      <FallOutlined /> {item?.percent?.toFixed(2)}%
                    </div>
                  )}
                </div>
              </div>
              <div className="margin-bottom">
                <TonalStatistic />
              </div>
            </div>
          ))}
        </div>
      )}
      <Drawer title="Что отображает эта таблица?" onClose={onClose} open={open}>
        <p className="purple-border">
          В таблице представлены ТОП-4 источника за период с наиболее высокими
          показателями ERR и количеством просмотров.
        </p>
        <p className="title-small">Как интерпретировать данные</p>
        <ol>
          <li>
            Временные интервалы: Вы можете выбрать различные временные интервалы
            для анализа динамики.
          </li>
        </ol>
        <p className="title-small">Источники данных</p>
        <ul>
          <li>Telegram</li>
          <li>Facebook</li>
          <li>Twitter</li>
          <li>Instagram</li>
          <li>Вконтакте</li>
          <li>Одноклассники</li>
          <li>Дзен</li>
        </ul>
        <p className="gray-block">
          <p className="gray-title">ПРИМЕЧАНИЕ</p>Данные обновляются в реальном
          времени, что позволяет вам следить за актуальными трендами и реакцией
          аудитории на ваш контент
        </p>
      </Drawer>
    </div>
  );
};

export default TopSources;
